import { Component, OnInit } from '@angular/core';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { Subject, Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
@Component({
  selector: 'app-landing-page-booking-widget',
  templateUrl: './landing-page-booking-widget.component.html',
  styleUrls: ['./landing-page-booking-widget.component.scss']
})
export class LandingPageBookingWidgetComponent implements OnInit {
  statusModal: BsModalRef;
  bookingWidget: FormGroup;
  brand: any;

  private unsubscribe: Subject<void> = new Subject<void>();
  private subscription: Subscription;
  constructor(
    private fb: FormBuilder,
    public modalService: BsModalService,
    private loyaltyService: LoyaltyService,
    private hotelManagementService: HotelManagementService
  ) {
    this.modalService.onHide
    .takeUntil(this.unsubscribe).subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.type == "hca-wizard") {
          if (this.statusModal.content.srcObject.action == "action1") {
            // Resets the form data
          }
        }
        
      }
    })
   }

   getBookingWidget(brandId) {
    // this.loyaltyService.getBookingWidget(brandId).subscribe(res => {
    //   console.log('=========== catalog booking widget data ========', res);
    //   if(res.error == 0) {
    //     if(!res.responseObj || res.responseObj.showBookingWidget == false) {
    //       this.initForm('false');
    //     }else { 
    //       this.initForm('true');
    //     }
    //   }
    // }, err => {
    //   console.error('Error fetching loyalty catalog booking widget', err);
    // })
  }

   saveForm() {
    this.hotelManagementService.getSelectedBrand()
    let formData = {
      brandId: this.hotelManagementService.getSelectedBrand().brandId,
      bookingWidgetTo: this.bookingWidget.value
    }
    console.log(formData);
    this.loyaltyService.saveLoyaltyWebsite(formData).subscribe(res => {
      console.log(res);
    }, err => {
      console.error('Error Saving', err.message);
    })
  }

   initForm(data?: any) {
    console.log(data);
    this.bookingWidget = this.fb.group({
      languageId: [1],
      showBookingWidget: [data ? data : ''],
    })
  }


   cancel() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-wizard',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to cancel out of configuring the Booking Widget?',
      action1: 'Yes',
      action2: 'No',
      action: '',
      style: 'active'
    }
  }


  ngOnInit() {
    this.subscription = this.loyaltyService.brandState
    .subscribe((state: any) => {
      this.brand = state.brand;
      this.getBookingWidget(this.brand.brandId);
    });
    this.initForm(null);
  }

  ngAfterViewInit(){
    this.brand = this.hotelManagementService.getSelectedBrand(); 
    this.getBookingWidget(this.brand ? this.brand.brandId : null);
  
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/landing-page-booking-widget/landing-page-booking-widget.component.ts